webpackJsonp([170786371021445],{

/***/ 769:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/home/ramshabukhari/my-blog-env/please/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. I will answer to the message as soon as possible.</p>","frontmatter":{"title":"Success"}},"footnote":{"id":"/home/ramshabukhari/my-blog-env/please/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>A personal blog intended to have a digital record of the things that excite me &#x3C;> Tech, Photos and Books</li>\n<li>delivered by <a href=\"https://www.netlify.com/\">Netlify</a></li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{"slug":"/success/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---success-7399702a0c57c7e4daa7.js